export default __webpack_public_path__ + "static/media/8.ab8e7371.jpeg";